import { GoBackProps } from "./types";
import "./i18n";
import { useTranslation } from "react-i18next";
import { Button } from "@pickit/pickit-components";

const Back = ({ testId, onClick, id }: GoBackProps) => {
  const { t } = useTranslation();
  return (
    <Button
      testId={testId}
      onClick={onClick}
      label={t("back:goBack")}
      size="medium"
      width="220"
      hierarchy="secondary"
      iconName="arrow-left"
    >
    </Button>
  );
};

export default Back;
